export enum MimeType {
  CSV = "application/csv",
  DXF = "application/dxf",
  DXF_VIA_SVG = "application/dxf_via_svg",
  PDF = "application/pdf",
  SVG = "application/svg",
  ZIP = "application/zip",
}

const fileExtensions: { [key in MimeType]: string } = {
  [MimeType.CSV]: "csv",
  [MimeType.DXF]: "dxf",
  [MimeType.DXF_VIA_SVG]: "dxf",
  [MimeType.PDF]: "pdf",
  [MimeType.SVG]: "svg",
  [MimeType.ZIP]: "zip",
};

/**
 * Native browser download implementation
 */
function downloadFile(
  content: string | Blob,
  filename: string,
  mimeType: string,
): void {
  const blob =
    content instanceof Blob ? content : new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export class Download {
  public title: string;
  protected content = "";
  protected readonly mimeType: MimeType;
  constructor(title: string, mimeType: MimeType) {
    this.title = title;
    this.mimeType = mimeType;
  }
  public createFileName(name: string = this.title) {
    return `${name}.${fileExtensions[this.mimeType]}`;
  }
  public getExtension(): string {
    return fileExtensions[this.mimeType].toUpperCase();
  }
  public async saveAs(name: string = this.title, prefix = "") {
    await this.getContent().then((content: string | Blob) => {
      downloadFile(content, this.createFileName(prefix + name), this.mimeType);
    });
  }
  public getContent(): Promise<string | Blob> {
    return new Promise<string>((resolve) => {
      resolve(this.content);
    });
  }
}
